<template><div /></template>

<script>
  export default {
    name: 'CorrigeODistDasEntidadesDaBdgd'
  };
</script>
